import { FC } from 'react';
import Loading from '~/components/commonUi/Loading/Loading';
import { CandidatePhoto } from '~/definitions/candidates';

interface Props {
    loadingCandidatePhoto?: boolean;
    candidatePhoto?: CandidatePhoto;
}

const CandidateImagePreview: FC<Props> = ({ loadingCandidatePhoto, candidatePhoto }) => {
    const renderImageContent = () => {
        if (loadingCandidatePhoto) {
            return (
                <div className="flex justify-center items-center h-full">
                    <Loading testId={'loading-candidate-photo'} />
                </div>
            );
        }

        if (candidatePhoto?.url) {
            return (
                <img
                    className="min-w-[215px]"
                    id="candidate-img"
                    src={candidatePhoto?.url}
                    alt={candidatePhoto?.name}
                />
            );
        }

        return 'Bilde mangler';
    };

    return (
        <div id="image-preview" className="col-span-7 col-start-5">
            {renderImageContent()}
        </div>
    );
};

export default CandidateImagePreview;
